import { useCallback, useEffect, useState } from 'react';
import { ThumbUpOutlined } from '@mui/icons-material';
import { TIP_LIBRARY_FOLLOWING_LEARNED_ACCOUNTS_V1 } from '../constants/local_storage_constants';

const readLearnedAccounts = () => {
    try {
        const value = JSON.parse(localStorage.getItem(TIP_LIBRARY_FOLLOWING_LEARNED_ACCOUNTS_V1));
        return Array.isArray(value) ? value.filter(uid => typeof uid === 'string') : [];
    } catch {
        return [];
    }
};

export default function LibraryFollowingIntro({ uid, hasEpisodes, hasFollows }) {
    const [learnedAccounts, setLearnedAccounts] = useState(readLearnedAccounts);
    const learned = learnedAccounts.includes(uid);
    const markLearned = useCallback(() => {
        if (!uid || learned) return;
        const next = [...new Set([...readLearnedAccounts(), ...learnedAccounts, uid])];
        setLearnedAccounts(next);
        try {
            localStorage.setItem(TIP_LIBRARY_FOLLOWING_LEARNED_ACCOUNTS_V1, JSON.stringify(next));
        } catch {
            // Dismissal still works in memory when browser storage is unavailable.
        }
    }, [uid, learned, learnedAccounts]);

    useEffect(() => {
        // An empty state teaches the same idea; avoid another welcome when episodes arrive.
        if (!hasEpisodes) markLearned();
    }, [hasEpisodes, markLearned]);

    if (!uid || (hasEpisodes && learned)) return null;

    if (!hasEpisodes) {
        return (
            <div className='libraryFollowingEmptyCard libraryFollowingIntroCard'>
                <h3 className='libraryFollowingEmptyTitle'>
                    {hasFollows ? 'No episodes here yet' : 'Make this feed yours'}
                </h3>
                <p className='libraryFollowingEmptySubtitle'>
                    {hasFollows
                        ? 'New episodes from the people and shows you follow will appear here.'
                        : (
                            <>
                                Tap <ThumbUpOutlined fontSize='inherit' className='settingsPreferenceInlineIcon' titleAccess='thumbs up' /> to follow people and shows.
                                {' '}Their latest episodes will appear here.
                            </>
                        )}
                </p>
            </div>
        );
    }

    return (
        <aside className='libraryFollowingIntroCard libraryFollowingWelcomeCard' aria-label='About Following'>
            <p>Latest episodes from people and shows you follow.</p>
            <button type='button' className='libraryFollowingDismiss' onClick={markLearned}>
                Got it
            </button>
        </aside>
    );
}
